<template>
  <div v-if="notHiddenfields.length" class="fields">
    <FormField
      v-for="field in notHiddenfields"
      :key="field.name"
      :field="field"
      @locked="handleFieldLocked"
      @loading="(value) => handleLoadingFields(field, value)"
    />
  </div>
</template>
<script setup lang="ts">
interface Props {
  fields: FormField[];
}
const props = defineProps({
  fields: null
});

const emit = defineEmits(["locked", "loading"]);

const loadingFields = ref<FormField[]>([]);

const locked = ref<boolean>(false);

const notHiddenfields = computed<FormField[]>(() => {
  return props.fields.filter((field) => field.type !== 'hidden');
});

const handleFieldLocked = (bool) => {
  locked.value = bool;
  emit('locked', locked.value);
};
const handleLoadingFields = (field: FormField, loading) => {
  if (!loading) {
    loadingFields.value = loadingFields.value.reduce((acc, curr) => {
      if (curr !== field) {
        acc.push(curr);
      }
      return acc;
    }, []);
  } else {
    loadingFields.value.push(field);
  }
};
watchEffect(() => emit('loading', loadingFields.value.length > 0));
</script>
<style lang="scss" scoped>
.fields {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--gap_n);
}
</style>
